import { render } from "./CarregarPessoa.vue?vue&type=template&id=789d8a30&scoped=true"
import script from "./CarregarPessoa.vue?vue&type=script&lang=js"
export * from "./CarregarPessoa.vue?vue&type=script&lang=js"

import "./CarregarPessoa.vue?vue&type=style&index=0&id=789d8a30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789d8a30"]])

export default __exports__